
export const cleanFunction = (container) => {
    // This function is called before leaving a page.
    // Use it to destroy any instances, event listeners, or observers.
    // console.log('Cleaning up container:', container);
    return Promise.resolve();
};
